import React from 'react';

export const CertificateRow =
  require('../../src/front/Users/Certificate/Row').default;
export const FollowingBusinesses =
  require('../../src/front/pages/FollowingBusinesses').default;

export const Login = require('../../src/front/Users/Login').default;
export const Signup = require('../../src/front/Users/Signup').default;
export const EmailSignUpForm =
  require('../../src/front/Users/SignUp/EmailSignUpForm').default;
export const Skills = require('../../src/front/Users/Skills').default;

export const Payment = require('../../src/front/Payment').default;
